import { compose } from 'redux';
import { connect } from 'react-redux';
import { GetListQARequested, clearListQA } from '../../actions/QAListManagerment';
import withAuthUser from '../../common/WithAuthUser';
import FAQ, { Header } from '../../pages/FAQ/FAQ';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    QAList: state.qAListManagerment.qAList.data,
    role: Number(state.auth.credential.data.role),
    eventInfo: state.registration.registrationViewer.data,
    isAuthorized: state.auth.credential.isAuthorized,
    isCheckEvent: state.registration.registrationViewer.successInformation,
    customColorQA: state.registrationOrganizer.registrationOrganizer.data?.settings_colors_viewer,
});

const mapDispatchToProps = (dispatch) => ({
    getQAList: (companyID, params, locale) => {
        const formattedParams = {
            event_name: companyID,
            qa_type: locale === 'en' ? params.type + 2 : params.type,
            language: locale,
        };
        dispatch(GetListQARequested(formattedParams));
    },
    clearQAList: () => {
        dispatch(clearListQA());
    },
});

export const QAHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuthUser,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(FAQ);
